function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 8.22656,
  cy: 8,
  r: 8,
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.22656 1C4.37656 1 1.22656 4.15 1.22656 8C1.22656 11.85 4.37656 15 8.22656 15C12.0766 15 15.2266 11.85 15.2266 8C15.2266 4.15 12.0766 1 8.22656 1ZM7.35156 10.975L4.37656 8L5.60156 6.775L7.35156 8.525L10.8516 5.025L12.0766 6.25L7.35156 10.975Z",
  fill: "#0DB78D"
});

const SvgOperatorApproved = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgOperatorApproved, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/OperatorApproved.46b77158.svg";
export { ForwardRef as ReactComponent };